export default __webpack_public_path__ + "media/images/svg/star-icon-316a357233f6822897e576a892ddbcb1.svg";